<!-- Header -->
<app-header></app-header>

<!-- Main content -->
<div
  class="px-6 xl:px-20 py-10 text-gray-800 flex flex-col justify-center items-center"
>
  <!-- Contact Us Section -->
  <div class="max-w-7xl">
    <div class="text-center mb-10">
      <div class="flex w-full items-center justify-center gap-4 py-8">
        <div class="w-16 h-[3px] bg-[#00D5BE]"></div>

        <h1 class="text-4xl font-bold text-gray-800">
          {{ "CONTACT_PAGE.TITLE" | translate }}
        </h1>

        <div class="w-16 h-[3px] bg-[#00D5BE]"></div>
      </div>
      <p>
        {{ "CONTACT_PAGE.SUBTITLE" | translate }}
      </p>
    </div>

    <!-- Top Info Card -->
    <div
      class="flex flex-col gap-8 items-center bg-white shadow-xl rounded-2xl p-8 text-center mb-12 border"
    >
      <div class="text-[#009689] text-4xl">
        <img
          src="assets/icons/contact-main.svg"
          [alt]="'CONTACT_PAGE.INFO_CARD.ALT' | translate"
        />
      </div>
      <p class="text-gray-600 max-w-2xl mx-auto">
        {{ "CONTACT_PAGE.INFO_CARD.RESPONSE_TIME" | translate }}
      </p>
      <div class="space-y-2 text-gray-700">
        <p class="flex justify-center items-center gap-2">
          <svg
            width="20"
            height="20"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0423 5.10352L9.48638 9.27945C9.26391 9.40867 9.01121 9.47673 8.75393 9.47673C8.49666 9.47673 8.24396 9.40867 8.02148 9.27945L1.45898 5.10352"
              stroke="#009689"
              stroke-width="1.45833"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.584 2.91602H2.91732C2.1119 2.91602 1.45898 3.56893 1.45898 4.37435V13.1243C1.45898 13.9298 2.1119 14.5827 2.91732 14.5827H14.584C15.3894 14.5827 16.0423 13.9298 16.0423 13.1243V4.37435C16.0423 3.56893 15.3894 2.91602 14.584 2.91602Z"
              stroke="#009689"
              stroke-width="1.45833"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <strong
            >{{ "CONTACT_PAGE.INFO_CARD.EMAIL_LABEL" | translate }}:</strong
          >
          {{ "CONTACT_PAGE.INFO_CARD.EMAIL_VALUE" | translate }}
        </p>
        <p class="flex justify-center items-center gap-2">
          <svg
            width="20"
            height="20"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0865 12.0815C10.2371 12.1506 10.4067 12.1664 10.5675 12.1263C10.7283 12.0861 10.8706 11.9924 10.971 11.8605L11.2298 11.5215C11.3657 11.3404 11.5418 11.1934 11.7443 11.0921C11.9468 10.9909 12.1701 10.9382 12.3965 10.9382H14.584C14.9708 10.9382 15.3417 11.0918 15.6152 11.3653C15.8887 11.6388 16.0423 12.0097 16.0423 12.3965V14.584C16.0423 14.9708 15.8887 15.3417 15.6152 15.6152C15.3417 15.8887 14.9708 16.0423 14.584 16.0423C11.103 16.0423 7.76462 14.6595 5.30321 12.1981C2.84179 9.73668 1.45898 6.39828 1.45898 2.91732C1.45898 2.53054 1.61263 2.15961 1.88612 1.88612C2.15961 1.61263 2.53054 1.45898 2.91732 1.45898H5.10482C5.49159 1.45898 5.86252 1.61263 6.13601 1.88612C6.40951 2.15961 6.56315 2.53054 6.56315 2.91732V5.10482C6.56315 5.33122 6.51044 5.55451 6.40919 5.757C6.30794 5.9595 6.16094 6.13564 5.97982 6.27148L5.63857 6.52742C5.5047 6.62963 5.41035 6.77504 5.37154 6.93893C5.33273 7.10282 5.35185 7.27509 5.42565 7.42648C6.42219 9.45055 8.06117 11.0875 10.0865 12.0815Z"
              stroke="#009689"
              stroke-width="1.45833"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <strong
            >{{ "CONTACT_PAGE.INFO_CARD.SALES_LABEL" | translate }}:</strong
          >
          +966 11 510 0517
        </p>
        <p class="flex justify-center items-center gap-2">
          <svg
            width="20"
            height="20"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0865 12.0815C10.2371 12.1506 10.4067 12.1664 10.5675 12.1263C10.7283 12.0861 10.8706 11.9924 10.971 11.8605L11.2298 11.5215C11.3657 11.3404 11.5418 11.1934 11.7443 11.0921C11.9468 10.9909 12.1701 10.9382 12.3965 10.9382H14.584C14.9708 10.9382 15.3417 11.0918 15.6152 11.3653C15.8887 11.6388 16.0423 12.0097 16.0423 12.3965V14.584C16.0423 14.9708 15.8887 15.3417 15.6152 15.6152C15.3417 15.8887 14.9708 16.0423 14.584 16.0423C11.103 16.0423 7.76462 14.6595 5.30321 12.1981C2.84179 9.73668 1.45898 6.39828 1.45898 2.91732C1.45898 2.53054 1.61263 2.15961 1.88612 1.88612C2.15961 1.61263 2.53054 1.45898 2.91732 1.45898H5.10482C5.49159 1.45898 5.86252 1.61263 6.13601 1.88612C6.40951 2.15961 6.56315 2.53054 6.56315 2.91732V5.10482C6.56315 5.33122 6.51044 5.55451 6.40919 5.757C6.30794 5.9595 6.16094 6.13564 5.97982 6.27148L5.63857 6.52742C5.5047 6.62963 5.41035 6.77504 5.37154 6.93893C5.33273 7.10282 5.35185 7.27509 5.42565 7.42648C6.42219 9.45055 8.06117 11.0875 10.0865 12.0815Z"
              stroke="#009689"
              stroke-width="1.45833"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <strong
            >{{ "CONTACT_PAGE.INFO_CARD.SERVICE_LABEL" | translate }}:</strong
          >
          +966 920 012 099
        </p>
        <p class="flex justify-center items-center gap-2">
          <svg
            width="20"
            height="20"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.5837 7.29232C14.5837 10.933 10.5448 14.7247 9.18855 15.8958C9.06221 15.9908 8.90841 16.0421 8.75033 16.0421C8.59224 16.0421 8.43844 15.9908 8.3121 15.8958C6.95585 14.7247 2.91699 10.933 2.91699 7.29232C2.91699 5.74522 3.53157 4.26149 4.62554 3.16753C5.7195 2.07357 7.20323 1.45898 8.75033 1.45898C10.2974 1.45898 11.7812 2.07357 12.8751 3.16753C13.9691 4.26149 14.5837 5.74522 14.5837 7.29232Z"
              stroke="#009689"
              stroke-width="1.45833"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.75 9.47852C9.95812 9.47852 10.9375 8.49914 10.9375 7.29102C10.9375 6.08289 9.95812 5.10352 8.75 5.10352C7.54188 5.10352 6.5625 6.08289 6.5625 7.29102C6.5625 8.49914 7.54188 9.47852 8.75 9.47852Z"
              stroke="#009689"
              stroke-width="1.45833"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {{ "CONTACT_PAGE.INFO_CARD.LOCATION" | translate }}
        </p>
      </div>
    </div>

    <!-- Contact Info Cards Grid -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
      <!-- Email Card -->
      <div
        class="flex flex-col items-center gap-3 bg-white shadow-xl rounded-2xl p-6 text-center border"
      >
        <img
          src="assets/icons/contact-email.svg"
          [alt]="'CONTACT_PAGE.CARDS.EMAIL.ALT' | translate"
        />
        <h3 class="font-semibold text-gray-500">
          {{ "CONTACT_PAGE.CARDS.EMAIL.TITLE" | translate }}
        </h3>
        <p class="text-black text-sm">
          {{ "CONTACT_PAGE.CARDS.EMAIL.VALUE" | translate }}
        </p>
        <p class="text-xs text-gray-400">
          {{ "CONTACT_PAGE.CARDS.EMAIL.DESCRIPTION" | translate }}
        </p>
      </div>

      <!-- Sales Card -->
      <div
        class="flex flex-col items-center gap-3 bg-white shadow-xl rounded-2xl p-6 text-center border"
      >
        <img
          src="assets/icons/contact-phone.svg"
          [alt]="'CONTACT_PAGE.CARDS.SALES.ALT' | translate"
        />
        <h3 class="font-semibold text-gray-500">
          {{ "CONTACT_PAGE.CARDS.SALES.TITLE" | translate }}
        </h3>
        <p class="text-black text-sm">
          {{ "CONTACT_PAGE.CARDS.SALES.VALUE" | translate }}
        </p>
        <p class="text-xs text-gray-400">
          {{ "CONTACT_PAGE.CARDS.SALES.DESCRIPTION" | translate }}
        </p>
      </div>

      <!-- Service Card -->
      <div
        class="flex flex-col items-center gap-3 bg-white shadow-xl rounded-2xl p-6 text-center border"
      >
        <img
          src="assets/icons/contact-phone.svg"
          [alt]="'CONTACT_PAGE.CARDS.SERVICE.ALT' | translate"
        />
        <h3 class="font-semibold text-gray-500">
          {{ "CONTACT_PAGE.CARDS.SERVICE.TITLE" | translate }}
        </h3>
        <p class="text-black text-sm">
          {{ "CONTACT_PAGE.CARDS.SERVICE.VALUE" | translate }}
        </p>
        <p class="text-xs text-gray-400">
          {{ "CONTACT_PAGE.CARDS.SERVICE.DESCRIPTION" | translate }}
        </p>
      </div>

      <!-- Location Card -->
      <div
        class="flex flex-col items-center gap-3 bg-white shadow-xl rounded-2xl p-6 text-center border"
      >
        <img
          src="assets/icons/contact-location.svg"
          [alt]="'CONTACT_PAGE.CARDS.LOCATION.ALT' | translate"
        />
        <h3 class="font-semibold text-gray-500">
          {{ "CONTACT_PAGE.CARDS.LOCATION.TITLE" | translate }}
        </h3>
        <p class="text-black text-sm">
          {{ "CONTACT_PAGE.CARDS.LOCATION.VALUE" | translate }}
        </p>
        <p class="text-xs text-gray-400">
          {{ "CONTACT_PAGE.CARDS.LOCATION.DESCRIPTION" | translate }}
        </p>
      </div>
    </div>

    <!-- Contact Form & Sidebar -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <!-- Contact Form -->
      <div
        class="flex flex-col gap-2 lg:col-span-2 bg-white shadow-xl rounded-2xl p-8 border"
      >
        <h3 class="text-xl font-bold text-black">
          {{ "CONTACT_PAGE.FORM.TITLE" | translate }}
        </h3>
        <p class="mb-4">
          {{ "CONTACT_PAGE.FORM.SUBTITLE" | translate }}
        </p>

        <!-- Success Message -->
        <div *ngIf="submitSuccess" class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
          <div class="flex items-center">
            <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
            </svg>
            <span>Your email client has been opened with a pre-filled message. Please send the email to complete your inquiry!</span>
          </div>
        </div>

        <!-- Error Message -->
        <div *ngIf="submitError" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          <div class="flex items-center">
            <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
            </svg>
            <span>Unable to send your message. Please contact us directly at <a href="mailto:alosailimu@waseel.com" class="underline font-semibold">alosailimu&#64;waseel.com</a></span>
          </div>
        </div>

        <form
          (ngSubmit)="onSubmit()"
          class="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          <div class="flex flex-col">
            <label for="name" class="text-sm font-semibold text-gray-700 mb-1">
              {{ "CONTACT_PAGE.FORM.NAME_LABEL" | translate }} <span class="text-red-500">*</span>
            </label>
            <input
              id="name"
              type="text"
              [placeholder]="'CONTACT_PAGE.FORM.NAME_PLACEHOLDER' | translate"
              [(ngModel)]="formData.name"
              name="name"
              required
              class="border rounded-lg p-2 focus:ring-2 focus:ring-[#009689] outline-none"
            />
          </div>

          <div class="flex flex-col">
            <label for="email" class="text-sm font-semibold text-gray-700 mb-1">
              {{ "CONTACT_PAGE.FORM.EMAIL_LABEL" | translate }} <span class="text-red-500">*</span>
            </label>
            <input
              id="email"
              type="email"
              [placeholder]="'CONTACT_PAGE.FORM.EMAIL_PLACEHOLDER' | translate"
              [(ngModel)]="formData.email"
              name="email"
              required
              class="border rounded-lg p-2 focus:ring-2 focus:ring-[#009689] outline-none"
            />
          </div>

          <div class="flex flex-col">
            <label for="phone" class="text-sm font-semibold text-gray-700 mb-1">
              {{ "CONTACT_PAGE.FORM.PHONE_LABEL" | translate }}
            </label>
            <input
              id="phone"
              type="text"
              [placeholder]="'CONTACT_PAGE.FORM.PHONE_PLACEHOLDER' | translate"
              [(ngModel)]="formData.phone"
              name="phone"
              class="border rounded-lg p-2 focus:ring-2 focus:ring-[#009689] outline-none"
            />
          </div>

          <div class="flex flex-col">
            <label
              for="subject"
              class="text-sm font-semibold text-gray-700 mb-1"
            >
              {{ "CONTACT_PAGE.FORM.SUBJECT_LABEL" | translate }} <span class="text-red-500">*</span>
            </label>
            <input
              id="subject"
              type="text"
              [placeholder]="
                'CONTACT_PAGE.FORM.SUBJECT_PLACEHOLDER' | translate
              "
              [(ngModel)]="formData.subject"
              name="subject"
              class="border rounded-lg p-2 focus:ring-2 focus:ring-[#009689] outline-none"
            />
          </div>

          <div class="flex flex-col md:col-span-2">
            <label
              for="message"
              class="text-sm font-semibold text-gray-700 mb-1"
            >
              {{ "CONTACT_PAGE.FORM.MESSAGE_LABEL" | translate }} <span class="text-red-500">*</span>
            </label>
            <textarea
              id="message"
              [placeholder]="
                'CONTACT_PAGE.FORM.MESSAGE_PLACEHOLDER' | translate
              "
              [(ngModel)]="formData.message"
              name="message"
              rows="5"
              class="border rounded-lg p-2 focus:ring-2 focus:ring-[#009689] outline-none"
            ></textarea>
          </div>

          <!-- CAPTCHA Component -->
          <div class="md:col-span-2">
            <app-captcha
              [showError]="captchaError"
              (captchaResolved)="onCaptchaResolved($event)"
              (captchaError)="onCaptchaError()">
            </app-captcha>
          </div>

          <button
            type="submit"
            [disabled]="isSubmitting"
            [class]="isSubmitting
              ? 'flex items-center justify-center gap-3 bg-gray-400 text-white rounded-lg py-2 px-4 mt-2 md:col-span-2 cursor-not-allowed'
              : 'flex items-center justify-center gap-3 bg-[#009689] text-white rounded-lg py-2 px-4 mt-2 md:col-span-2 hover:bg-[#00BBA7] transition duration-500'"
          >
            <!-- Loading Spinner -->
            <svg *ngIf="isSubmitting" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>

            <!-- Send Icon -->
            <svg *ngIf="!isSubmitting"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_2514_2132)">
                <path
                  d="M8.47857 12.651C8.50073 12.7062 8.53926 12.7533 8.58898 12.786C8.6387 12.8187 8.69723 12.8355 8.75673 12.8339C8.81622 12.8324 8.87382 12.8127 8.9218 12.7775C8.96978 12.7423 9.00585 12.6933 9.02515 12.637L12.8168 1.55364C12.8355 1.50195 12.8391 1.44602 12.8271 1.39238C12.8151 1.33874 12.7881 1.28962 12.7493 1.25076C12.7104 1.2119 12.6613 1.18491 12.6077 1.17295C12.554 1.16099 12.4981 1.16455 12.4464 1.18322L1.36307 4.97489C1.30677 4.99419 1.25773 5.03026 1.22253 5.07824C1.18732 5.12622 1.16764 5.18382 1.16611 5.24332C1.16459 5.30281 1.1813 5.36134 1.214 5.41106C1.24671 5.46078 1.29384 5.49931 1.34907 5.52147L5.9749 7.37647C6.12114 7.43502 6.254 7.52257 6.36548 7.63386C6.47696 7.74514 6.56476 7.87784 6.62357 8.02397L8.47857 12.651Z"
                  stroke="white"
                  stroke-width="1.16667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.7489 1.25195L6.36719 7.63304"
                  stroke="white"
                  stroke-width="1.16667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_2514_2132">
                  <rect width="14" height="14" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <span>
              {{ isSubmitting ? ('CONTACT_PAGE.FORM.SENDING_BUTTON' | translate) : ('CONTACT_PAGE.FORM.SUBMIT_BUTTON' | translate) }}
            </span>
          </button>
        </form>
      </div>

      <!-- Sidebar Section (Social Links + Support Hours + Links) -->
      <div class="space-y-6">
        <div
          class="flex flex-col items-center bg-gradient-to-r from-[#009689] to-[#009966] text-white rounded-2xl p-8 shadow-xl"
        >
          <h3 class="text-xl font-semibold mb-3">
            {{ "CONTACT_PAGE.SIDEBAR.CONNECT.TITLE" | translate }}
          </h3>
          <p class="text-center text-lg mb-4 text-[#CBFBF1]">
            {{ "CONTACT_PAGE.SIDEBAR.CONNECT.SUBTITLE" | translate }}
          </p>
          <div class="flex justify-center gap-4 mb-4">
            <button class="bg-[#34ac95] p-4 rounded-2xl">
              <img
                src="assets/icons/contact-facebook.svg"
                [alt]="'CONTACT_PAGE.SIDEBAR.CONNECT.FACEBOOK_ALT' | translate"
              />
            </button>
            <button class="bg-[#34ac95] p-4 rounded-2xl">
              <img
                src="assets/icons/contact-tweeter.svg"
                [alt]="'CONTACT_PAGE.SIDEBAR.CONNECT.TWITTER_ALT' | translate"
              />
            </button>
            <button class="bg-[#34ac95] p-4 rounded-2xl">
              <img
                src="assets/icons/contact-linkedin.svg"
                [alt]="'CONTACT_PAGE.SIDEBAR.CONNECT.LINKEDIN_ALT' | translate"
              />
            </button>
            <button class="bg-[#34ac95] p-4 rounded-2xl">
              <img
                src="assets/icons/contact-instagram.svg"
                [alt]="'CONTACT_PAGE.SIDEBAR.CONNECT.INSTAGRAM_ALT' | translate"
              />
            </button>
          </div>
          <div
            class="flex flex-col gap-2 items-center border-t w-full pt-6 border-[#00BBA7]"
          >
            <p class="text-sm text-[#CBFBF1]">
              {{ "CONTACT_PAGE.SIDEBAR.CONNECT.HOURS_DAYS" | translate }}
            </p>
            <p class="font-bold text-lg mt-1">
              {{ "CONTACT_PAGE.SIDEBAR.CONNECT.HOURS_TIME" | translate }}
            </p>
          </div>
        </div>
        <div class="bg-white shadow-xl rounded-2xl p-6 border">
          <h4 class="font-bold mb-3 text-gray-800">
            {{ "CONTACT_PAGE.SIDEBAR.LINKS.TITLE" | translate }}
          </h4>
          <ul class="space-y-2 text-[#009689] text-sm">
            <li>
              <a href="/faq" class="hover:underline cursor-pointer">
                {{ "CONTACT_PAGE.SIDEBAR.LINKS.FAQ" | translate }}
              </a>
            </li>
            <li>
              <a
                (click)="openKeyClockLogin()"
                class="hover:underline cursor-pointer"
              >
                {{ "CONTACT_PAGE.SIDEBAR.LINKS.GET_STARTED" | translate }}
              </a>
            </li>
            <li>
              <a href="/" class="hover:underline cursor-pointer">
                {{ "CONTACT_PAGE.SIDEBAR.LINKS.HOME" | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<app-footer layout="slim"></app-footer>
